// import 'animate.css';
// import Swiper, {Navigation} from 'swiper';
// import 'swiper/css';
// import 'swiper/css/navigation';
import './scss/popup.scss';

const elText = $('#popup_selectcoin .text');
const elRange = $('#popup_selectcoin .range');
const elIconRange = $('#popup_selectcoin .icon-range');

elRange.val(0);

elRange.on('input', function () {
    const value = $(this).val();
    elText.html(value);

    elIconRange.css('left', value + '%')

});
